import React, { createContext, useContext, useState } from 'react';

const DEBUG_KEY = 'portal_debug';

interface PortalDebugContextType {
  debugMode: boolean;
  toggleDebug: () => void;
}

const PortalDebugContext = createContext<PortalDebugContextType>({
  debugMode: false,
  toggleDebug: () => {},
});

export const PortalDebugProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [debugMode, setDebugMode] = useState(() => localStorage.getItem(DEBUG_KEY) === 'true');

  const toggleDebug = () => {
    setDebugMode(prev => {
      const next = !prev;
      localStorage.setItem(DEBUG_KEY, String(next));
      return next;
    });
  };

  return (
    <PortalDebugContext.Provider value={{ debugMode, toggleDebug }}>
      {children}
    </PortalDebugContext.Provider>
  );
};

export const usePortalDebug = () => useContext(PortalDebugContext);
